import { memo } from "react";
import { Drawer, Button, Select, Space } from "antd";
import FormItemWrapper from "~/components/common/FormItemWrapper/FormItemWrapper";

interface LandsatMosaicFilterPanelProps {
  visible: boolean;
  onClose: () => void;
  year?: number;
  setYear: (year?: number) => void;
  period?: number;
  setPeriod: (period?: number) => void;
  onSearch: () => void;
  onReset: () => void;
}

const LandsatMosaicFilterPanel: React.FC<LandsatMosaicFilterPanelProps> = ({
  visible,
  onClose,
  year,
  setYear,
  period,
  setPeriod,
  onSearch,
  onReset,
}) => {
  const yearOptions = [
    { label: 'Tất cả các năm (1997 - 2026)', value: undefined as any },
    ...Array.from({ length: 30 }, (_, i) => {
      const y = 2026 - i;
      return { label: `Năm ${y}`, value: y };
    }),
  ];

  const periodOptions = [
    { label: 'Tất cả các kỳ', value: undefined as any },
    { label: 'Kỳ 1 (Tháng 1 - Tháng 2)', value: 1 },
    { label: 'Kỳ 2 (Tháng 3 - Tháng 4)', value: 2 },
    { label: 'Kỳ 3 (Tháng 5 - Tháng 6)', value: 3 },
    { label: 'Kỳ 4 (Tháng 7 - Tháng 8)', value: 4 },
    { label: 'Kỳ 5 (Tháng 9 - Tháng 10)', value: 5 },
    { label: 'Kỳ 6 (Tháng 11 - Tháng 12)', value: 6 },
  ];

  return (
    <Drawer
      title="Lọc ảnh Landsat Ghép Định Kỳ (CDSE)"
      placement="right"
      closable={true}
      onClose={onClose}
      open={visible}
      width={380}
      style={{ position: 'absolute' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <FormItemWrapper label="Năm quan sát">
          <Select
            style={{ width: '100%' }}
            placeholder="Tất cả các năm"
            allowClear
            value={year}
            onChange={(val) => setYear(val !== undefined ? Number(val) : undefined)}
            options={yearOptions}
          />
        </FormItemWrapper>

        <FormItemWrapper label="Kỳ quan sát (2 tháng / kỳ)">
          <Select
            style={{ width: '100%' }}
            placeholder="Tất cả các kỳ"
            allowClear
            value={period}
            onChange={(val) => setPeriod(val !== undefined ? Number(val) : undefined)}
            options={periodOptions}
          />
        </FormItemWrapper>

        <Space style={{ marginTop: 8 }}>
          <Button type="primary" onClick={onSearch}>
            Tìm kiếm
          </Button>
          <Button onClick={onReset}>
            Đặt lại
          </Button>
        </Space>
      </div>
    </Drawer>
  );
};

export default memo(LandsatMosaicFilterPanel);
